import React from "react";

export const AdjustmentDetailContext = React.createContext(null);

export const useAdjustmentDetailContext = () => {
  const context = React.useContext(AdjustmentDetailContext);

  if (!context) throw new Error("Adjustment Detail Context not provided!");

  return context;
};
